// management-frontend/src/services/FileSelectorService.js

const FileSelectorService = {
  /**
   * Abre o seletor de arquivos do navegador.
   *
   * @param {Object} options
   * @param {string} options.accept Tipos de arquivos permitidos
   * @param {boolean} options.multiple Permite selecionar vários arquivos
   *
   * @returns {Promise<File|File[]|null>}
   */

  selectFile: ({ accept = "", multiple = false } = {}) => {
    return new Promise((resolve) => {
      const input = document.createElement("input");

      input.type = "file";
      input.style.display = "none";
      input.accept = accept;
      input.multiple = multiple;

      let resolved = false;

      const cleanup = () => {
        window.removeEventListener("focus", handleFocus);

        if (document.body.contains(input)) {
          document.body.removeChild(input);
        }
      };

      const finish = (value) => {
        if (resolved) {
          return;
        }

        resolved = true;
        cleanup();
        resolve(value);
      };

      const handleFocus = () => {
        setTimeout(() => {
          if (!input.files?.length) {
            finish(null);
          }
        }, 300);
      };

      input.addEventListener(
        "change",
        () => {
          const files = Array.from(input.files || []);

          if (!files.length) {
            finish(null);
            return;
          }

          finish(multiple ? files : files[0]);
        },
        { once: true },
      );

      window.addEventListener("focus", handleFocus, { once: true });

      document.body.appendChild(input);

      input.click();
    });
  },
};

export default FileSelectorService;
